// extracted by mini-css-extract-plugin
export var numpadContainer = "_n2-1";
export var phoneButton = "_n2-0";